import { useEffect, useState } from "react";

let resizeTimer: any = null
export default function (resizeTimerValue = 250) {
    const [isWindowResizing, setIsWindowResizing] = useState<Boolean>(false);
    const onResizeEnd = () => {
        setIsWindowResizing(false)
    }
    const onResize = () => {
        if (!isWindowResizing) {
            setIsWindowResizing(true)
        }
        resizeTimer = setTimeout(onResizeEnd, resizeTimerValue)
    }
    useEffect(() => {
        window.addEventListener("resize", onResize);
        return () => {
            clearInterval(resizeTimer)
            window.removeEventListener("resize", onResize);
        }
    })


    return { isWindowResizing }
}
